<template>
  <span>
    <svg class="icon-color-1" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.4 25H16.6C22.6 25 25 22.6 25 16.6V9.4C25 3.4 22.6 1 16.6 1H9.4C3.4 1 1 3.4 1 9.4V16.6C1 22.6 3.4 25 9.4 25Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11.5004 16.972L15.7244 12.736L11.5004 8.5" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 26 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
  }
}
</script>